import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
// import { assignmentItems } from '../../../../store/INV/AssignmentItems/assignmentItemsSlice';
import PersonsNotInPlan from './PersonsNotInPlan';
import PersonsInPlan from './PersonsInPlan';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { getPersonListAllRotation } from '../../../../store/HR/Raqeeb/raqeebSlice';
import { updateRotationPlanPerson } from '../../../../store/HR/Raqeeb/raqeebSlice';

const AssignmentPerson = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // حالات لتخزين القوائم
  const [personsByPlan, setPersonsByPlan] = useState<any[]>([]);
  const [personsNotInPlan, setPersonsNotInPlan] = useState<any[]>([]);
  // const [selectedPersons, setSelectedPersons] = useState<any[]>([]);

  const [selectedPersonsInPlan, setSelectedPersonsInPlan] = useState<any[]>([]);
  const [selectedPersonsNotInPlan, setSelectedPersonsNotInPlan] = useState<any[]>([]);

  useEffect(() => {
    dispatch(getPersonListAllRotation());
  }, [dispatch]);
  const { PersonListAllRotationPlan: allData } = useAppSelector((s) => s.Raqeeb);

  useEffect(() => {
    if (allData) {
      setPersonsByPlan(allData.filter((f: any) => f.rotationPlanId === id));
      // ~~~~~~~~~~~~~~~~~~~~~~~~~~
      const notInPlan = allData?.filter((f: any) => f.rotationPlanId !== id);
      setPersonsNotInPlan(notInPlan);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allData]);

  // const moveToPlan = () => {
  //   const updatedItemsByInv = [...personsByPlan, ...selectedPersons];
  //   const updatedItemsNotInInv = personsNotInPlan?.filter(
  //     (item) => !selectedPersons?.map((sel) => sel.id).includes(item.id)
  //   );

  //   // تحديث القوائم
  //   setPersonsByPlan(updatedItemsByInv);
  //   setPersonsNotInPlan(updatedItemsNotInInv);
  //   setSelectedPersons([]);
  // };

  const moveToPlan = () => {
    const updatedItemsByPlan = [...personsByPlan, ...selectedPersonsNotInPlan];
    const updatedItemsNotInPlan = personsNotInPlan?.filter(
      (item) => !selectedPersonsNotInPlan?.map((sel) => sel.id).includes(item.id)
    );

    // تحديث القوائم
    setPersonsByPlan(updatedItemsByPlan);
    setPersonsNotInPlan(updatedItemsNotInPlan);
    setSelectedPersonsNotInPlan([]); // إعادة تعيين الحالة
  };

  // const removeFromPlan = () => {
  //   const updatedItemsByInv = personsByPlan?.filter(
  //     (item) => !selectedPersons?.map((sel) => sel.id).includes(item.id)
  //   );
  //   const updatedItemsNotInInv = [...personsNotInPlan, ...selectedPersons];

  //   // تحديث القوائم
  //   setPersonsByPlan(updatedItemsByInv);
  //   setPersonsNotInPlan(updatedItemsNotInInv);
  //   setSelectedPersons([]);

  //   // هنا يمكنك إضافة منطق لإرسال البيانات إلى الخادم
  //   // console.log('الأصناف التي تم إخراجها من المخزن:', updatedItemsByInv);
  // };

  const removeFromPlan = () => {
    const updatedItemsByPlan = personsByPlan?.filter(
      (item) => !selectedPersonsInPlan?.map((sel) => sel.id).includes(item.id)
    );
    const updatedItemsNotInPlan = [...personsNotInPlan, ...selectedPersonsInPlan];

    // تحديث القوائم
    setPersonsByPlan(updatedItemsByPlan);
    setPersonsNotInPlan(updatedItemsNotInPlan);
    setSelectedPersonsInPlan([]); // إعادة تعيين الحالة
  };

  const onSubmit = () => {
    setIsSubmitting(true);

    let body = {
      ids: personsByPlan?.map((m) => m.id),
      rotationPlanId: id,
    };

    dispatch(updateRotationPlanPerson(body))
      .unwrap()
      .then(() => {
        CustomAlert({ action: 'Add' , msg: 'تمت عملية تعديل خطط الخضور للموظفين' });
      })
      .catch((error: any) => {
        CustomAlert({ action: 'Error' });
      })
      .finally(() => setIsSubmitting(false));
  };

  const location = useLocation();
  const { name } = location?.state || {};
  var BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome',
    },
    {
      name: 'خطة الحضور',
      link: '/RAQ/RotationPlan',
    },
    {
      name: 'تعيين الموظفين',
      link: null,
    },
  ];
  return (
    <>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('تعيين الموظفين')} subtitle={name} />

        <div className="ms-auto">
          <button
            disabled={isSubmitting}
            onClick={() => onSubmit()}
            type="submit"
            className="btn me-1 btn-lg btn-theme rounded-1"
            id="SaveSubmit">
            {isSubmitting ? (
              <div className="spinner-border spinner-border-sm me-2"></div>
            ) : (
              // <i className="fas fa-lg fa-fw me-2 fa-plus"></i>
              <i className="fa fa-save btn-lg fa-fw me-1"></i>
            )}
            {t('Save')}
          </button>
          <Link
            to="/RAQ/RotationPlan"
            replace
            className="btn me-1 btn-lg btn-secondary   rounded-1">
            <i className="fa fa-arrow-left me-2"></i>
            {t('Back')}
          </Link>
        </div>
      </div>
      <>
        <div className="row gx-3">
          {/* <PersonsInPlan
            itemsByPerson={personsByPlan}
            selectedPersons={selectedPersons}
            setSelectedPersons={setSelectedPersons}
            removeFromPlan={removeFromPlan}
          />
          <PersonsNotInPlan
            personNotInPlan={personsNotInPlan}
            selectedPersons={selectedPersons}
            setSelectedPersons={setSelectedPersons}
            moveToPlan={moveToPlan}
          /> */}

          <PersonsInPlan
            itemsByPerson={personsByPlan}
            selectedPersons={selectedPersonsInPlan}
            setSelectedPersons={setSelectedPersonsInPlan}
            removeFromPlan={removeFromPlan}
          />
          <PersonsNotInPlan
            personNotInPlan={personsNotInPlan}
            selectedPersons={selectedPersonsNotInPlan}
            setSelectedPersons={setSelectedPersonsNotInPlan}
            moveToPlan={moveToPlan}
          />
        </div>
      </>
    </>
  );
};

export default AssignmentPerson;

// <div className="text-center">
// <button
//   disabled={isSubmitting}
//   onClick={() => onSubmit()}
//   type="submit"
//   className="btn me-1 btn-lg btn-theme mb-1"
//   id="SaveSubmit">
//   {isSubmitting ? (
//     <div className="spinner-border spinner-border-sm me-2"></div>
//   ) : (
//     // <i className="fas fa-lg fa-fw me-2 fa-plus"></i>
//     <i className="fa fa-save btn-lg fa-fw me-1"></i>
//   )}
//   {t('Save')}
// </button>
// <Link
//   to="/INV/InventorySettings/Inventory"
//   replace
//   className="btn me-1 btn-lg btn-default mb-1">
//   <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
// </Link>
// </div>
